// extracted by mini-css-extract-plugin
module.exports = {"label":"styles__label___2AgvY","portalPermissionsContainer":"styles__portalPermissionsContainer___17mKr","portalPermissionsHeader":"styles__portalPermissionsHeader___3Gp5g"};